import { BaseService, ServiceResponse } from './base.service';

export class StarredCoursesService extends BaseService {
  
  async getStarredCourses(userId: string): Promise<ServiceResponse<string[]>> {
    return this.withErrorHandling(async () => {
      const { data, error } = await this.supabase
        .from('user_starred_courses')
        .select('course_id')
        .eq('user_id', userId)
        .order('created_at', { ascending: false });
        
      if (error) throw error;
      return data?.map(item => item.course_id) || [];
    });
  }
  
  async addStarredCourse(userId: string, courseId: string): Promise<ServiceResponse<void>> {
    return this.withErrorHandling(async () => {
      const { error } = await this.supabase
        .from('user_starred_courses')
        .upsert({
          user_id: userId,
          course_id: courseId,
          created_at: new Date().toISOString()
        });
        
      if (error) throw error;
      return undefined;
    });
  }
  
  async removeStarredCourse(userId: string, courseId: string): Promise<ServiceResponse<void>> {
    return this.withErrorHandling(async () => {
      const { error } = await this.supabase
        .from('user_starred_courses')
        .delete()
        .eq('user_id', userId)
        .eq('course_id', courseId);
        
      if (error) throw error;
      return undefined;
    });
  }
  
  async toggleStarredCourse(userId: string, courseId: string): Promise<ServiceResponse<boolean>> {
    return this.withErrorHandling(async () => {
      // Check if course is already starred
      const { data: existing } = await this.supabase
        .from('user_starred_courses')
        .select('course_id')
        .eq('user_id', userId)
        .eq('course_id', courseId)
        .maybeSingle();
        
      if (existing) {
        // Remove from starred
        await this.removeStarredCourse(userId, courseId);
        return false;
      } else {
        // Add to starred
        await this.addStarredCourse(userId, courseId);
        return true;
      }
    });
  }
  
  async isCourseStarred(userId: string, courseId: string): Promise<ServiceResponse<boolean>> {
    return this.withErrorHandling(async () => {
      const { data, error } = await this.supabase
        .from('user_starred_courses')
        .select('course_id')
        .eq('user_id', userId)
        .eq('course_id', courseId)
        .maybeSingle();
        
      if (error) throw error;
      return !!data;
    });
  }
} 